import { mixpanel } from 'analytics';

export function trackSubmitMixPanelEvent(event: string) {
	if (mixpanel && typeof mixpanel.track === 'function') mixpanel.track(event);
}
